module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row border-bottom"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "row wrapper border-bottom white-bg page-heading"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loader"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('h2', [_c('router-link', {
    attrs: {
      "to": "/company"
    }
  }, [_c('img', {
    staticStyle: {
      "max-height": "40px"
    },
    attrs: {
      "src": "/static/img/common/logo.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-outline btn-xs btn-bitbucket",
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" Logout\n            ")])], 1)], 1), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, _vm._l((_vm.menuList), function(menu) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": menu.link
      }
    }, [_vm._v(_vm._s(menu.name))])], 1)
  }), 0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader-img"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/loading.gif",
      "alt": "Now Loading...",
      "width": "80px",
      "height": "80px"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3156c881"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/Base.vue
// module id = 444
// module chunks = 1